var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 6.16667V3C3.25 2.72386 3.47386 2.5 3.75 2.5H8.58333C8.85948 2.5 9.08333 2.72386 9.08333 3V6.16667C9.08333 6.44281 8.85948 6.66667 8.58333 6.66667H3.75C3.47386 6.66667 3.25 6.44281 3.25 6.16667Z",
    stroke: "black",
    strokeWidth: 1.66667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.418 16.9997V13.833C12.418 13.5569 12.6418 13.333 12.918 13.333H17.7513C18.0274 13.333 18.2513 13.5569 18.2513 13.833V16.9997C18.2513 17.2758 18.0274 17.4997 17.7513 17.4997H12.918C12.6418 17.4997 12.418 17.2758 12.418 16.9997Z",
    stroke: "black",
    strokeWidth: 1.66667
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.418 10.3333V3C12.418 2.72386 12.6418 2.5 12.918 2.5H17.7513C18.0274 2.5 18.2513 2.72386 18.2513 3V10.3333C18.2513 10.6095 18.0274 10.8333 17.7513 10.8333H12.918C12.6418 10.8333 12.418 10.6095 12.418 10.3333Z",
    stroke: "black",
    strokeWidth: 1.66667
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 17.0003V9.66699C3.25 9.39085 3.47386 9.16699 3.75 9.16699H8.58333C8.85948 9.16699 9.08333 9.39085 9.08333 9.66699V17.0003C9.08333 17.2765 8.85948 17.5003 8.58333 17.5003H3.75C3.47386 17.5003 3.25 17.2765 3.25 17.0003Z",
    stroke: "black",
    strokeWidth: 1.66667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartIcon);
export default __webpack_public_path__ + "static/media/chartIcon.b9d3996151ceb4b81e8258afa8d2ec96.svg";
export { ForwardRef as ReactComponent };